import React from 'react';
import { useIntl } from 'react-intl';

import ActionButton from 'components/widgets/ActionButton/ActionButton';
import { useModalContext } from 'context/modal/modal';
import { ActionButtonTypesEnum } from 'interface';

import styles from './DefaultModalActionButton.module.scss';

interface DefaultModalActionButtonProps {
  onAccept?: (event?: any) => void;
  acceptButtonText?: string | undefined;
  acceptButtonType?: ActionButtonTypesEnum | undefined;
  loading?: boolean;
}

export const DefaultModalActionButton = ({
  onAccept,
  acceptButtonText,
  acceptButtonType,
  loading,
}: DefaultModalActionButtonProps) => {
  const intl = useIntl();
  const modalContext = useModalContext();
  const buttonLabel = acceptButtonText || intl.formatMessage({ id: 'DefaultModal.buttonConfirm', defaultMessage: 'Confirm' });

  return onAccept ? (
    <ActionButton
      title={buttonLabel}
      className={styles.actionButton}
      disabled={loading}
      onClick={() => {
        modalContext.closeModal();
        onAccept();
      }}
      submit
      type={acceptButtonType ? ActionButtonTypesEnum[acceptButtonType] : ActionButtonTypesEnum.danger}
    />
  ) : null;
};
